import React from 'react';
import { enterPrisesPaths } from '../../routes/enterprises';
import { useNavigate } from 'react-router-dom';
import { coachPaths } from '../../routes/coach';

const FailedCreatePassword = () => {
    const navigate = useNavigate();

    return (
        <div
            style={{
                backgroundColor: "#f4f4f4",
                minHeight: "100vh",
                margin: 0,
                paddingBlock: 40,
                fontFamily: "'Lato', Helvetica, Arial, sans-serif",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center"
            }}
        >
            <link
                href="https://fonts.googleapis.com/css?family=Lato:400,700,400italic,700italic"
                rel="stylesheet"
            />
            <table width="100%" cellPadding="0" cellSpacing="0">
                <tbody>
                    <tr>
                        <td align="center">
                            <table width="100%" style={{ maxWidth: 600 }}>
                                <tbody>
                                    <tr>
                                        <td
                                            align="center"
                                            style={{
                                                backgroundColor: "#ffffff",
                                                padding: "0px 0px 10px",
                                                borderRadius: "4px 4px 0 0",
                                                fontSize: 24,
                                                fontWeight: 700,
                                                color: "#111",
                                                lineHeight: "32px",
                                            }}
                                        >
                                            <div style={{
                                                marginBottom: "30px", backgroundColor: "#e6e6e6", width: "100%", paddingTop: "14px"
                                            }}>
                                                <img
                                                    src="https://api.nu-vio.com:4005/logo.png"
                                                    alt="Nuvio Logo"
                                                    title="Nuvio"
                                                    style={{
                                                        border: 0, maxWidth: "83px",
                                                        width: "100%",
                                                        objectFit: "contain"
                                                    }}
                                                />
                                            </div>
                                            <img
                                                src="https://api.nu-vio.com:4005/oops.webp"
                                                width="200"
                                                height="80"
                                                alt="Oops"
                                                style={{ display: "block", border: 0 }}
                                            />
                                            <p style={{ marginTop: 20, marginBottom: "0px" }}>
                                                Generate Password Link Not Found
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            align="center"
                                            style={{
                                                backgroundColor: "#ffffff",
                                                padding: "0 30px 20px",
                                                fontSize: 18,
                                                color: "#666",
                                                lineHeight: "28px",
                                            }}
                                        >
                                            <p style={{ margin: 0 }}>
                                                The link you used to generate your password is either
                                                invalid or has already expired.
                                            </p>
                                            <div style={{ marginTop: "20px" }}>
                                                <button
                                                    className='ct_yellow_btn ct_darkblue_btn px-5'
                                                    onClick={() => navigate(enterPrisesPaths?.Enterprise)}
                                                >
                                                    Continue to Nuvio
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            align="left"
                                            style={{
                                                backgroundColor: "#ffffff",
                                                padding: "0 30px 40px",
                                                borderRadius: "0 0 4px 4px",
                                                fontSize: 18,
                                                color: "#666",
                                                lineHeight: "25px",
                                            }}
                                        >
                                            <p style={{ margin: 0 }}>
                                                Cheers,
                                                <br />
                                                <span style={{ fontWeight: "600", color: "#000" }}>Nuvio Team</span>
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td align="center" style={{ padding: "0px 10px 0" }}>
                            <table width="100%" style={{ maxWidth: 600 }}>
                                <tbody>
                                    <tr>
                                        <td
                                            align="center"
                                            style={{
                                                backgroundColor: "rgb(2 48 71)",
                                                padding: "30px",
                                                borderRadius: 4,
                                                fontSize: 16,
                                                color: "#fff",
                                                lineHeight: "24px",
                                            }}
                                        >
                                            <h2
                                                style={{
                                                    fontSize: 16,
                                                    fontWeight: 700,
                                                    color: "#fff",
                                                    margin: 0,
                                                }}
                                            >
                                                Need more help?
                                            </h2>
                                            <p style={{ margin: "5px 0 0" }}>
                                                <a
                                                    onClick={() =>
                                                        navigate(coachPaths.ContactUs, { state: { data: "landing" } })
                                                    }
                                                    style={{
                                                        color: "#fff",
                                                        textDecoration: "none",
                                                    }}
                                                >
                                                    Contact our support team
                                                </a>
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
};

export default FailedCreatePassword;